import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../lib/request";


export const searchCountries = createAsyncThunk(
  "countries/searchCountries",
  async (
    { query = "", page = 0, size = 270 } = {},
    { rejectWithValue }
  ) => {
    try {

   
      let url = `/authn/countries/search?page=${page}&size=${size}`;

      if (query?.trim()) {
        url += `&q=${encodeURIComponent(query.trim())}`;
      }


      const response = await get(
        url,
        null,
        { skipAuth: false } 
      );

      return Array.isArray(response) ? response : [];

    } catch (error) {

      console.error("Countries API error:", error);

      return rejectWithValue(error.message);

    }
  }
);

const countriesSlice = createSlice({
  name: "countries",
  initialState: {
    countries: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearCountries: (state) => {
      state.countries = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {

    builder

      .addCase(searchCountries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(searchCountries.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action.payload || [];
      })

      .addCase(searchCountries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  },
});

export const { clearCountries } = countriesSlice.actions;

export default countriesSlice.reducer;
